import React, { useContext } from 'react'
import { LanguageContext } from '../context'

function Co2() {
  const { t } = useContext(LanguageContext)
  return (
    <div className='content-parent'>
      <h3 className='impact-title mb-12'>{`"Mon impact positif sur l'environnement"`}</h3>
      <div className='flex gap-10 my-10'>
        <div className='impact-box'>
          <div className='impact-box-title'>{t('impact.number_of_tripe')}</div>
          <div className='impact-box-number'>
            3
          </div>
        </div>
        <div className='impact-box'>
          <div className='impact-box-title'>{t('impact.co2_title')}</div>
          <div className='impact-box-number'>
            120kg
          </div>
        </div>

      </div>
      <p className='impact-text'>
        {t('impact.text')}
      </p>

    </div>
  )
}

export default Co2
